import { render, staticRenderFns } from "./myWallet.vue?vue&type=template&id=f5ba5626&scoped=true&"
import script from "./myWallet.vue?vue&type=script&lang=js&"
export * from "./myWallet.vue?vue&type=script&lang=js&"
import style0 from "./myWallet.vue?vue&type=style&index=0&id=f5ba5626&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ba5626",
  null
  
)

export default component.exports